import SummaryBlock from "../../components/SummaryBlock/SummaryBlock";
import Headline from "../../components/Title/Headlines";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import './YourQuotePage.scss'
import CONSTANTS from "../../Constants";
import { Link, useNavigate } from "react-router-dom";
import { Button, Input } from "../../components/Forms/Forms";
import fetchApiData from "../../apiHandlers/fetchApiData";
import { isMobile } from "../../helpers/helpers";
import MobileStickyBlock from "../../components/mobile-sticky-block/mobileStickyBlock";
import MobileYourQuoteHeader from "../../components/Operations/MobileOperationsComponents/MobileYourQuoteHeader";
import PopIn from "../../components/PopIn/PopIn";
import Quote from "../../components/QuoteContent/Quote";
import useBodyClass from '../../custom-Hooks/useBodyClass';
import { setBasketId } from "../../redux-files/actions/action";
import { pushToGTMTracker, pushEventToGTM } from "../../helpers/trackerManager";
import MobileMailPopinForm from "../../components/MobileMailPopinForm/MobileMailPopinForm";

const YourQuotePage = () => {
    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const selectedMandatoryAdditionalForfFromStore = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const storeSelectedOperations = useSelector(state => state.ndel_store.selectedOperations)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const dealer = useSelector(state => state.ndel_store.dealer)
    const selectedMileageStepCode = useSelector(state => state.ndel_store.selectedMileageSteps.key)

    const [totalPrice, setTotalPrice] = useState(0)
    const [emailInput, setEmailInput] = useState('')
    const [emailErrorLabel, setEmailErrorLabel] = useState('')
    const [showReceiveEmailPopIn, setShowReceiveEmailPopIn] = useState(false)
    const [sendingEmailLoader, setSendingEmailLoader] = useState(false)
    const [showMailForm, setShowMailForm] = useState(false)
    
    const [widthPage, setWidthPage] = useState(isMobile())
    const dispatch = useDispatch()
    // let history = useHistory()
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)
        console.log('Your quote useEffect run ...')
        let totPrice = 0
        selectedForfaitFromStore.map(forfait => {
            totPrice += forfait.Items[0].Prix
            if (forfait.forfaitFamilyCode === 'FCT0002') {
                selectedMandatoryAdditionalForfFromStore.map(mandOp => {
                    totPrice += mandOp.Items[0].Prix
                })
            }
        })
        setTotalPrice(totPrice)
        pushToGTMTracker('quote-page', window.siteConfig.quotingDevis.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()), dealer)
    }, []);

    useEffect(() => {
        window.addEventListener('resize', () => {
          let browserZoomLevel = window.innerWidth;
          if (browserZoomLevel <= 800) {
            setWidthPage(true);
          }else{
            setWidthPage(false);
          }
        })
      })

    const sendQuoteMail = () => {
        setSendingEmailLoader(true)
        let foraitsFamilyCodes = []
        let forfaitsRef = []
        // let listInterventions = []
        selectedForfaitFromStore.forEach((forfait) => {
            forfaitsRef.push(forfait.Items[0].Ref)
            foraitsFamilyCodes.push(forfait.forfaitFamilyCode)
        })
        selectedMandatoryAdditionalForfFromStore.forEach((Mandforfait) => {
            forfaitsRef.push(Mandforfait.Items[0].Ref)
        })
        // storeSelectedOperations.forEach(operation => {
        //     listInterventions.push({ "InterventionId": operation.interventionId, "interventionLabel": operation.interventionLabel });
        // })
        const fetchApi = new fetchApiData()
        fetchApi.getSendQuoteMail({
            "carDetails": { ...vehicleInfo },
            "dealerInfos": { ...dealer },
            "customerEmail": emailInput,
            "mileageStep": selectedMileageStepCode,
            "selectedServices": {
                // comment: this.props.store.commentServices,
                "subFunctionCodes": { ...foraitsFamilyCodes },
                "forfaitRefs": { ...forfaitsRef },
            },
            "listeInterventions": [],
        }).then(
            result => {
                if (result.d.Statut === 0) {
                    setSendingEmailLoader(false)
                    setShowReceiveEmailPopIn(true)
                    dispatch(setBasketId(result.d.BasketId))
                }
                else {
                    setSendingEmailLoader(false)
                    console.error('une erreur s\'est produite')
                }
            })
            .catch(error => {
                setSendingEmailLoader(false)
                console.error(error)
            });
        pushEventToGTM({
            pageName: 'quoting',
            eventAction: 'Display::Popin::Email',
            eventLabel: CONSTANTS.LABELS.quote_email2,
            eventCategory: 'Content'
        })
    }
    const activeInput = emailInput.length >= 1 ? 'activeInput' : ''
    const exactBackgroundImage = showReceiveEmailPopIn ? 'mailSent' : 'mailForm' //for Mobile
    const LoadingClass = (sendingEmailLoader ? " Loading" : "");
    const popInEmailReceived = <div className='popin-email-received'>
        <p className='label1'>{CONSTANTS.LABELS.quote_popin_email_label1}</p>
        <p className='label2'>{CONSTANTS.LABELS.quote_popin_email_label2}</p>
    </div>
    useBodyClass(`page-yourQuote`)
    return (
        <>
            {!isMobile() && <SummaryBlock />}
            {!isMobile() && <Headline
                Title={CONSTANTS.LABELS.quote_title}
                SubTitle={CONSTANTS.LABELS.quote_subtitle}
            />}

            <div className='quote-content-wrapper'>

                <Quote
                    title={CONSTANTS.LABELS.header_quote_ariane3}
                />
            </div>
            {!widthPage && <div className='sticky-button-block'>
                <div className={`email-block ${activeInput} ${LoadingClass}`}>
                    <Input
                        placeholder={CONSTANTS.SITE_INFO.EMAILMASK}
                        onChange={(e) => {
                            setEmailInput(e.target.value.toLowerCase().trim())
                        }
                        }
                        name="email"
                        errorLabel={emailErrorLabel}
                        Value={emailInput}
                    />
                    <Button isDisabled={emailInput.length < 1}
                        handlClick={() => {
                            sendQuoteMail()
                        }
                        }
                    >
                        {CONSTANTS.LABELS.quote_email2}
                    </Button>
                </div>
                <Link to={CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE}
                    onClick={() => pushEventToGTM({
                        pageName: 'quoting',
                        eventAction: 'Redirection::Internal::Appointment',
                        eventLabel: CONSTANTS.LABELS.quote_booking,
                        eventCategory: 'Content'
                    })}
                    className='link-as-button'>
                    {CONSTANTS.LABELS.quote_booking}
                </Link>
            </div>}

            {/*DESKTOP popin to show that the email has been sent*/}
            {!isMobile() && showReceiveEmailPopIn && <PopIn
                title={CONSTANTS.LABELS.quote_popin_email_title}
                content={popInEmailReceived}
                primaryButtonLabel={CONSTANTS.LABELS.quote_popin_email_no_booking}
                secondaryButtonLabel={CONSTANTS.LABELS.quote_booking}
                inverseButtons={true}
                handlePrimaryButton={() => {
                    setShowReceiveEmailPopIn(false);
                    pushEventToGTM({
                        pageName: 'quoting',
                        eventAction: 'Close::Popin::Email',
                        eventLabel: CONSTANTS.LABELS.quote_popin_email_no_booking,
                        eventCategory: 'Content'
                    })
                }
                }
                handleSecondaryButton={() => {
                    navigate(CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE) /*history.push(CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE)*/
                    pushEventToGTM({
                        pageName: 'quoting',
                        eventAction: 'Redirection::Internal::Appointment',
                        eventLabel: CONSTANTS.LABELS.quote_booking,
                        eventCategory: 'Content'
                    })
                }
                }
            />}

            {/* mobile only sticky block */}
            {isMobile() && <MobileStickyBlock
                labels={[
                    CONSTANTS.LABELS.needs_basket_maintenance_label9,
                    CONSTANTS.LABELS.quote_nopackage,
                    CONSTANTS.LABELS.needs_basket_label2,
                    CONSTANTS.LABELS.quote_mobile_send_email,
                    CONSTANTS.LABELS.quote_add_operation,
                    CONSTANTS.LABELS.quote_booking
                ]}
                selectedOperations={storeSelectedOperations}
                totalPrice={totalPrice}
                handleFirstButton={() => {
                    setShowMailForm(true);
                    // document.body.classList.add('body-scroll')
                }
                }
                handleSeconButton={() => navigate(CONSTANTS.SITE_ROUTS.OPERATIONSPAGE) /*history.push(CONSTANTS.SITE_ROUTS.OPERATIONSPAGE)*/}
                handleThirdButton={() => navigate(CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE)/*history.push(CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE)*/}
            ></MobileStickyBlock>}

            {isMobile() && showMailForm && < MobileMailPopinForm handleGoBackClick={() => setShowMailForm(false)} />}
            {/* mobile only mail popin form */}

        </>
    );
}
export default YourQuotePage;